import { type User } from '@kalos/kalos-rpc';

import { getKalosLogoUrl } from '../../../hooks/react-query/useKalosLogoQuery';
import { EmailClientService } from '../../../tools/helpers';

const buildBody = (login: string, password: string, logoUrl: string) => `<body>

    <table cellpadding="0" cellspacing="0" class="main-table" style="max-width:800; margin:auto; border:1px solid #ddd; background-color:#f1f1f1;" align="center">
     <tr>
    <td height="12"></td>
  </tr>
  <tr>
    <td>
    </td>
  </tr>

    <tr>
      <td height="10" colspan="3"></td>
    </tr>
    <tr>
      <td width="2%"></td>
      <td width="96%">
        <table style="width:100%; margin:auto; background-color:#fff;" cellpadding="0" cellspacing="0">
          <tr>
            <td width="2%"></td>
            <td width="96%">
              <table style="width:100%;" cellpadding="0" cellspacing="0">
                <tr>
                  <td height="12"></td>
                </tr>
                <a><img src='${logoUrl}' width="175"	alt="email-logo" style="display:block; background-color: #711313"/></a>

                <tr>
                  <td height="23"></td>
                </tr>
                <tr>
                  <td height="22"></td>
                </tr>
                <tr>
                  <td>
                    <h3 style="font-size:20px; color:#4d4d4d; font-family:Arial, Helvetica, sans-serif; margin:0;">
                         <b>Welcome to Kalos Services!</b>
                    </h3>
                  </td>
                </tr>
                <tr>
                  <td height="14"></td>
                </tr>
                <tr>
                  <td>
                    Customer Account Login:
                    <p style="margin:1; font-size:14px; color:#262626; line-height:20px; font-family:Arial, Helvetica, 'sans-serif';">

            Your username is:<b>${login} </b> <br>
            Your password is: <b>${password} </b>(case-sensitive - must be changed upon initial login)
            <br><br>
            <a href="https://customer.kalosflorida.com/auth/login" style="color:#711313; text-decoration:none; font-weight:bold;">Click here to login to your account</a>
                    </p>
                  </td>
                </tr>
                <tr>
                  <td height="10"></td>
                </tr>
                <tr>


                  <td height="10"></td>
                </tr>
                <tr>
                  <td>
                    <table style="width:100%;" cellpadding="1" cellspacing="1">
                      <tr>

        Thanks again for choosing Kalos Services Inc.
                        <br>
                        <br>
                                         <b>The Kalos Services Staff</b>
                        <br>
                                          (352) 243-7088
<p style="margin:1; font-size:14px; color:#262626; line-height:20px; font-family:Arial, Helvetica, 'sans-serif';">
      Call or text 352-243-7099 for simply great service!
<br>
  <br>
We offer 24 hour HVAC emergency service & air conditioning preventative maintenance.
    <br>
<a href="https://www.kalosflorida.com/service/air-conditioning-maintenance/">https://www.kalosflorida.com/service/air-conditioning-maintenance/</a>

                    </p>



                    </table>

                  </td>
                </tr>
                <tr>
                  <td height="18"></td>
                </tr>
                <tr>

                </tr>
                  <tr>
                  <td height="18"></td>
                </tr>
              </table>
            </td>
            <td width="2%"></td>
          </tr>
        </table>
      </td>
      <td width="2%"></td>
    </tr>
    <tr>
      <td height="13" colspan="3"></td>
    </tr>
    <tr>
      <td width="2%"></td>
      <td width="96%">
           <table style="width:100%; border-top:1px solid #d8d8d8;" cellpadding="0" cellspacing="0">
          <tr>
            <td height="10" colspan="2"></td>
          </tr>
          <tr>
            <td width="80%" align="right" valign="middle">
              <p style="font-size:10px; color:#595959; font-family:Arial, Helvetica, sans-serif; font-weight:300; line-height:13px; text-align:left" >
               This message has been sent automatically from http://app.KalosFlorida.com.
                                          If you have any questions or concerns regarding this document,
                                          please either reply to this email or call (352) 243-7088<br />

              </p>
            </td>
            <td width="20%" align="right">
            </td>
          </tr>
        </table>
      </td>
      <td width="2%"></td>
    </tr>
    <tr>
      <td height="30" colspan="3"></td>
    </tr>
  </table>
  </body>`;

export const sendCustomerWelcomeEmail = async (newUser: User) => {
  const logoUrl = await getKalosLogoUrl('onDark');
  return await EmailClientService.sendMail({
    recipient: newUser.email,
    subject: 'Subj. KalosFlorida.com New Account Confirmation ',
    from: 'office@kalosflorida.com',
    body: buildBody(newUser.email, newUser.pwd, logoUrl),
  });
};
